// The feature flags on in this office (src/flags.ts: per Raft server, decided by the server). The page hears them
// from GET /prejoin and in "welcome" (setFlags) and hides what's off: dress.js the bodies behind one (look-model.js
// BODY_FLAGS). The office refuses what's off anyway; this only keeps it out of sight.
let on = [];
const heard = new Set();
/** The office said which flags are on (a list of names; anything else is ignored). */
export function setFlags(f) { if (!Array.isArray(f)) return; on = f.filter((x) => typeof x === 'string'); for (const fn of heard) fn(on); }
/** Call fn whenever the flags are set (dress.js redraws an open panel). */
export const onFlags = (fn) => heard.add(fn);
/** The flags on here. */
export const flags = () => on;
